module.exports = __webpack_public_path__ + "static/pen-caa483215572653aaa9e9bedb57884f8.png";